import { render, staticRenderFns } from "./ChargingPointDiscontinuities.vue?vue&type=template&id=2a1452c8"
import script from "./ChargingPointDiscontinuities.vue?vue&type=script&lang=js"
export * from "./ChargingPointDiscontinuities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports